(function($, undefined) {
	"use strict";

	function init() {
		$('.wizard_step6 .wizard__questions').on('submit', onFormSubmit);
		$('.wizard-delete-emergency-btn').on('click', onDeleteBtnClick);
		$('.wizard-criticals__btn').on('click', onAddAnotherClick);
		$('.wizard-criticals .form-input').on('keyup', onInputKeyup);
	}

	function onFormSubmit(e) {
		let form = $(e.currentTarget);
		let items = form.find('.location-form-editable-list-item_full:not(.template)');
		let fields = getFieldsJSON();
		e.preventDefault();

		$('[name="users"]', form).val(items.map((i, el) => el.dataset.itemId).get().join());
		$('[name="fields"]').val(JSON.stringify(fields));

		form.get(0).submit();
	}
	
	function getFieldsJSON() {
		let responses = $('input[type="radio"][value="yes"]:checked');
		let newRows = $('.wizard-criticals__row input');
		let answers = [];

		responses.each((index, check) => {
			let checkbox = $(check);
			let td = checkbox.closest('tr').find('td').eq(0);
			let item = {};
			item.name = td.text();
			item.text = "Enter building info";
			answers.push(item);
		});
		
		newRows.each((index, input) => {
			let item = {};
			item.name = input.value;
			item.text = "Enter building info";
			item.custom = true;
			answers.push(item);
		});

		return ({
			fields: answers
		});
	}

	function onAddAnotherClick(e) {
		let template = $('.wizard-criticals__clone');
		let table = $('.wizard-criticals__table');
		let clone = template.clone(true, true).removeClass('wizard-criticals__clone');
		let input = clone.find('input');
		let lastIndex = table.find('input[type="text"]').get().reduce((prev, current) => {
			let index = parseInt(current.name.split('new-field-')[1]);
			return isNaN(index) ? prev : Math.max(prev, index);
		}, 0);

		clone.addClass('wizard-criticals__row')
		input.attr('name', `${input.attr('name')}${lastIndex + 1}`);
		input.addClass('required');
		table.append(clone);
	}

	function onDeleteBtnClick({ currentTarget }) {
		let btn = $(currentTarget);
		$('tr[data-id]').removeAttr('data-id');
		btn.closest('tr').attr('data-id', 'wizard-emergency-item');
	}

	function onInputKeyup({ currentTarget }) {
		let val = currentTarget.value;
		currentTarget.classList.toggle('error', val.length == 0);
	}

	$(init);
	
})(jQuery);